import { WelcomeRoadSC } from 'components/WelcomeRoad/WelcomeRoadSC';
import { ResetPassword as ResetPasswordComp } from 'imaginarity-platform-registration';
import { styled } from 'imaginarity-react-ui';
import * as React from 'react';
import Div100vh from 'react-div-100vh';
import { connect } from 'react-redux';
import { ApplicationState } from "services/ApplicationState/ApplicationState";
import { ComponentWithMappedApplicationState } from 'services/ApplicationState/HelperInterfaces';
import { AppEntry } from 'services/ApplicationState/MasterLayoutRouter';
import { ThemeContext } from 'styled-components';

const mapper = (state: ApplicationState) => ({ params: state.params });

export const ResetPasswordAppEntry: AppEntry = {
    contentRenderer: () => <RPWD />,
    icon: "user",
    name: "reset_password",
    title: "general::reset password",
    route: "resetPassword/:token?",
    noLogin: true,
    hidden: true,
    left: {
        hidden: true,
    },
    right: {
        hidden: true,
    }
}

const Container = styled.div`
  position: relative;
  height: 100vh;
  display: grid;
  display: -ms-grid;
  grid-template-rows: 1fr auto 1fr;
  -ms-grid-rows: 1fr auto 1fr;
  -ms-grid-columns: 1fr;
`;

const Center = styled.div`
  grid-row: 2;
  -ms-grid-row: 2;
  -ms-grid-column: 1;
  grid-column: 1;
`;

const BackgroundContainer = styled(WelcomeRoadSC.FullContainer)`
    background: ${p => p.theme.colors.mainBackground};
`;

interface ResetPasswordProps extends ComponentWithMappedApplicationState<typeof mapper> {
}

const ResetPassword = (p: ResetPasswordProps) => {
    const token = p.params?.token as string | undefined;
    const theme = React.useContext(ThemeContext);

    return (
        <Div100vh>
            <BackgroundContainer>
                <Container >
                    <Center>
                        {token && <ResetPasswordComp resetToken={token} imageSource={theme.header?.logoURL ?? ""} />}
                    </Center>
                </Container>
            </BackgroundContainer>
        </Div100vh>
    );
}
const RPWD = connect(mapper)(ResetPassword);